import {
  CaretRightOutlined,
  RightCircleOutlined,
  RightOutlined
} from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { IRequestSteps } from 'client/components/schema/requests/compile-context/useRequestSteps';
import { ICreateRequestDto } from 'common/dto/RequestDto';
import { WidgetDisposalStepLogic } from 'common/schema/widget/disposal/WidgetDisposalStepLogic';
import { FormikContextType } from 'formik';
import { fromPairs } from 'lodash';
import * as React from 'react';

export interface IProcedureStepForwardButtonProps {
  title?: string;
  isPreview?: boolean;
  steps: IRequestSteps;
  formik: FormikContextType<ICreateRequestDto>;
  onForward?: () => any;
}

export function ProcedureStepForwardButton(
  props: IProcedureStepForwardButtonProps
) {
  const { steps, formik } = props;

  const errors = WidgetDisposalStepLogic.getStepErrors(steps.current, formik);

  return (
    <Tooltip
      title={
        errors.length > 0
          ? 'Compilare il modulo per procedere al passo successivo'
          : undefined
      }
    >
      <Button
        block
        size="large"
        type="primary"
        ghost
        onClick={() => {
          if (errors.length > 0) {
            formik.setTouched({
              values: fromPairs(errors.map(i => [i.metadata.id, true]))
            });

            // Comunque in modalità di anteprima permettiamo di procedere al
            // passo successivo
            if (props.isPreview) props.onForward?.();
          } else {
            props.onForward?.();
          }
        }}
      >
        {props.title ?? 'Avanti'} <RightOutlined />
      </Button>
    </Tooltip>
  );
}
